// app/javascript/controllers/billing_toggle_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "toggleButton",
    "monthlyPrice",
    "billingPeriod",
    "annualSaving",
    "billingInput"
  ]

  static classes = [
    "active",
    "inactive"
  ]

  connect() {
    // Set initial state to monthly
    this.setActiveBilling("monthly")
  }

  toggle(event) {
    const billing = event.currentTarget.dataset.billing
    this.setActiveBilling(billing)
  }

  setActiveBilling(billing) {
    // Update toggle button states
    this.toggleButtonTargets.forEach(button => {
      if (button.dataset.billing === billing) {
        this.setActiveButton(button)
      } else {
        this.setInactiveButton(button)
      }
    })

    // Update prices and periods
    this.monthlyPriceTargets.forEach(priceEl => {
      const price = billing === 'annual' ? priceEl.dataset.annual : priceEl.dataset.monthly
      priceEl.textContent = '$' + price
    })

    this.billingPeriodTargets.forEach(periodEl => {
      periodEl.textContent = billing === 'annual' ? '/year' : '/month'
    })

    // Show/hide annual savings
    this.annualSavingTargets.forEach(savingEl => {
      if (billing === 'annual') {
        savingEl.classList.remove('hidden')
      } else {
        savingEl.classList.add('hidden')
      }
    })

    // Update form inputs
    this.billingInputTargets.forEach(input => {
      input.value = billing
    })
  }

  setActiveButton(button) {
    // Remove inactive classes
    if (this.hasInactiveClass) {
      this.inactiveClasses.forEach(cls => button.classList.remove(cls))
    } else {
      button.classList.remove('text-gray-500')
    }

    // Add active classes
    if (this.hasActiveClass) {
      this.activeClasses.forEach(cls => button.classList.add(cls))
    } else {
      button.classList.add('bg-white', 'text-gray-900', 'shadow-sm', 'active')
    }
  }

  setInactiveButton(button) {
    // Remove active classes
    if (this.hasActiveClass) {
      this.activeClasses.forEach(cls => button.classList.remove(cls))
    } else {
      button.classList.remove('bg-white', 'text-gray-900', 'shadow-sm', 'active')
    }

    // Add inactive classes
    if (this.hasInactiveClass) {
      this.inactiveClasses.forEach(cls => button.classList.add(cls))
    } else {
      button.classList.add('text-gray-500')
    }
  }
}
